import {
  getDateHtmlComponent,
  getPropertiesFromItem,
  getSwatchHtmlComponent
} from '@/views/subscriptions/utils';

export default class OneTimesService {
  static CONTAINER_ID = `one-time-products-container`;
  static CONTAINER_CLASS = 'one-time-wrapper';

  static async getRenderContent({ parentView }) {
    const { onetimes } = await recharge.onetime.listOnetimes(
      parentView.session,
      {
        limit: 25,
        sort_by: 'id-asc'
      }
    );

    const htmlContent = (
      await Promise.all(
        onetimes
          .filter((x) => parseInt(x.price) === 0)
          .map(async (item) => {
            const { __image, __product_handle } = getPropertiesFromItem(item);
            const productImageUrl = await parentView.valiateProductImage(
              __image,
              __product_handle,
              item.external_product_id.ecommerce,
              item.external_variant_id.ecommerce
            );

            const swatchHtml =
              item.variant_title.includes(`/`) &&
              getSwatchHtmlComponent(item, __product_handle);
            const dateHtml = getDateHtmlComponent(item);

            return OneTimesService.getHtmlComponent({
              dateHtml,
              productImageUrl,
              item,
              swatchHtml
            });
          })
      )
    ).reduce((acc, curr) => `${acc} ${curr}`, '');

    const newDiv = document.createElement('div');

    newDiv.id = OneTimesService.CONTAINER_ID;
    newDiv.classList.add(OneTimesService.CONTAINER_CLASS);
    newDiv.innerHTML = htmlContent;

    return newDiv;
  }

  static getHtmlComponent({ dateHtml, productImageUrl, item, swatchHtml }) {
    return `
          <div class="profile-wrapper" style="max-width: 397px; ">
          <div class="subscription-group-title">
            <h4 class="next-order-title body-font-1">Your free gift</h4>
            ${dateHtml}
          </div>
            <div 
                class="account-card subscription" 
                style="display: flex;
                    align-items: center; 
                    gap: 6%; 
                    background-color: white; 
                    border-radius: 11px; 
                    padding: 20px 0px;">
                <div 
                    class="subscription-product-image product-core-block media" 
                    style="border-radius: 11px;">
                  <img 
                    src="${productImageUrl}"  
                    alt="Image of ${item.product_title}" 
                    style="width: 128px; border-radius: 11px;"/>
                </div>
                <div class="subscription-product-desc product-core-block core">
                  <p class="product-name title-font-11">${item.product_title}</p>
                  <div class="product-attribute-container">
                    <p class="product-options body-font-2" style="margin-bottom: 5px;">${item.variant_title}</p>
                    ${swatchHtml}
                  </div>
                </div>
            </div>
           </div>
        `;
  }
}
